<template>
  <div>
    <a-form
      style="margin: 40px auto 0;"
      :form="setpOneForm"
      v-bind="formLayout"
      @submit.prevent="nextStep"
    >
      <a-form-item label="商品类型">
        <a-radio-group
          button-style="solid"
          @change="handleDeviceTypeChange"
          v-decorator="['deviceType', {initialValue: rechargeForm1.deviceType}]"
        >
          <a-radio-button
            v-for="type in deviceTypes"
            :key="type.key"
            :value="type.key"
          >{{type.title}}</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="商品选择">
        <a-radio-group button-style="solid"
          v-decorator="['goodId', {initialValue: rechargeForm1.goodId,rules:[{required: true, message: '请选择商品'}]}]"
          @change="handleRechargeGoodsChange"
        >

          <a-radio-button
            v-for="type in goods"
            :key="type.id"
            :value="type.id"
            :data-price="type.price"
          >
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{type.description}}</span>
              </template>
              {{type.name}}
            </a-tooltip>
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="商品单价" v-if="rechargeForm1.goodId">
        <template v-if="rechargeForm1.deviceType === 1">
          {{rechargeForm1.price / 100}} 元
        </template>
        <template v-else>
          {{rechargeForm1.price / 100}} 元 / 设备
        </template>
      </a-form-item>
      <a-form-item label="购买数量">
        <a-input-number
          v-model="rechargeForm1.amountPerDevice"
          v-decorator="['amountPerDevice', {initialValue: 1,rules:[{required: true, message: '请填写购买数量'}]}]"
          style="width: 140px"
          :min="1"
        />
      </a-form-item>
      <a-form-item
        v-if="rechargeForm1.deviceType  !== 1"
        label="设备选择"
        required
        prop="deviceIds"
      >
        <a-table
          class="table-area"
          style="min-height: 100px;max-height: 400px"
          :columns="columns"
          :dataSource="tableData"
          :pagination="pagination"
          :loading="loading"
          :rowKey="record=>record.id"
          v-decorator="['deviceIds', {initialValue: [],rules:[{required: true, message: '请选择需要充值的设备'}]}]"
          :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: handleTableItemSelected }"
          @change="handleTableChange"
        >
          <template slot="deviceTypeCode" slot-scope="text, record">
            {{deviceTypes[text] ? deviceTypes[text]['title'] : ''}}
          </template>
        </a-table>
      </a-form-item>
      <a-form-item :wrapperCol="{span: 19, offset: 5}">
        <a-button type="primary" @click="nextStep">下一步</a-button>
      </a-form-item>
    </a-form>
    <a-divider />
    <div class="step-form-style-desc">
<!--      <h3>说明</h3>-->
<!--      <h4>转账到支付宝账户</h4>-->
<!--      <p>如果需要，这里可以放一些关于产品的常见问题说明。如果需要，这里可以放一些关于产品的常见问题说明。如果需要，这里可以放一些关于产品的常见问题说明。</p>-->
    </div>
  </div>
</template>

<script>

import columns from './tableConfig'
import { GetGoods } from '../../../../api/recharge'
import { GetDeviceListForOrder } from '../../../../api/deviceMana'

import store from '@/store'

const enumsData = store.state.enumsStore.enumsData
// const deviceTypes = enumsData.deviceType.reduce((deviceTypes, item) => {
//   deviceTypes[item.key] = item;
//   return deviceTypes;
// }, {});
const deviceTypes = {
  // 101: {
  //    "title": "门禁应用",
  //   "value": 101,
  //   "key": 101
  // },
  102: {
     "title": "访客应用",
    "value": 102,
    "key": 102
  },
  1: {
    "title": "短信包",
    "value": 1,
    "key": 1
  }
}

export default {
  name: 'Step1',
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    const formLayout = {
      labelCol: {
        lg: { span: 3 },
        sm: { span: 3 }
      },
      wrapperCol: {
        xs: { span: 19 },
        sm: { span: 19 }
      }
    }
    return {
      columns,
      deviceTypes,
      formLayout,
      setpOneForm: this.$form.createForm(this),
      rechargeForm1: JSON.parse(JSON.stringify(this.order)),
      rechargeForm1Rules:  {
        amountPerDevice: [{ required: true, message: '请填写购买数量！' }],
        goodId: [ { required: true, message: '请选择商品！', trigger: 'change' }],
        deviceIds: [{ required: true, message: '请选择需要充值的设备！' }],
      },
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0
      },
      goods: [],
      selectedRowKeys: [], // 列表多选钩中项的Id数组
      selectedRowItems: [], // 列表多选钩中项的数组
      tableData: [], // 列表表头项
      loading: false, // 列表内容是否在加载中
      form: this.$form.createForm(this)
    }
  },
  created() {
    this.$nextTick(async () => {
      this.rechargeForm1 = this.order
      this.setpOneForm.setFieldsValue(this.rechargeForm1)
      this.selectedRowKeys = this.rechargeForm1.deviceIds;
      this.selectedRowItems = this.rechargeForm1.devices;
      this.getDeviceTypeGoods()
      if (this.rechargeForm1.deviceType !== 1){
        this.getDeviceList(1)
      }
    })
  },
  methods: {
    nextStep () {
      this.setpOneForm.validateFields((err,value) => {
        if (!err) {
          console.log(value)
          let val = Object.assign(value,this.rechargeForm1)
          console.log(val)
          this.$emit('nextStep', this.rechargeForm1)
        }
      })
    },
    handleTableChange(pagination, filters, sorter){
      const { current } = pagination
      this.getDeviceList(current)
    },
    // table项勾选
    handleTableItemSelected(rowKeys, rowItems) {
      this.selectedRowKeys = rowKeys;
      this.selectedRowItems = rowItems;
      this.rechargeForm1.devices = rowItems
      this.rechargeForm1.deviceIds = rowKeys
      this.setpOneForm.setFieldsValue({deviceIds: rowKeys})
    },
    async getDeviceTypeGoods(){
      let param = {
        useTargetType: this.rechargeForm1.deviceType,
        page: 1,
        perPage: 20,
      }
      try {
        const res = await GetGoods(param)
        let goods = res.data.collection.reduce((goods, item) => {
          goods[item.id] = item;
          return goods;
        }, {});
        this.goods  = goods
      }catch (error){}
    },
    async getDeviceList(page = 1){
      let param = {
        deviceTypes: [this.rechargeForm1.deviceType],
        page: page,
        perPage: this.pagination.pageSize,
      }
      try {
        this.loading = true
        const res = await GetDeviceListForOrder(param)
        this.tableData  = res.data.collection
        this.pagination.current = page
        this.pagination.total = res.data.size
        this.loading = false
      }catch (error){
        this.loading = true
      }
    },
    handleDeviceTypeChange(e) {
      let id = e.target.value
      this.pagination.current = 1
      this.rechargeForm1.goodId = undefined
      this.rechargeForm1.price = 0
      this.rechargeForm1.deviceType = id
      console.log(this.order)
      this.getDeviceTypeGoods()
      if (id !== 1){
        this.getDeviceList(this.pagination.current)
      }
    },
    /* 商品点击*/
    handleRechargeGoodsChange(e) {
      let id = e.target.value
      console.log('change',e)
      this.rechargeForm1.goodId = id
      this.rechargeForm1.price = this.goods[id]? this.goods[id].price : 0
      this.rechargeForm1.goodsName = this.goods[id]? this.goods[id].name : ""
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
